module.exports = __webpack_public_path__ + "static/media/user-placeholder.32d108f8.png";